import React from 'react'

import NotFoundMessage from 'components/NotFoundMessage'
import { useHistory } from "react-router-dom"
import styles from './styles'
import UserRow from "../UserRow"
import { ROUTE_CONSTANTS } from "../../../utils/constants/routeConstants"

function UserTable(props) {
  const { users } = props

  const history = useHistory()
  const classes = styles()

  const handleRedirect = (user) => {
    history.push({
      pathname: ROUTE_CONSTANTS.USER_EDITOR,
      state: { user },
    })
  }
  
  return (
    users?.length > 0 ? (
      <table className={classes.dataTable}>
        <thead>
        <tr>
          <th>email</th>
          <th>nome de exibição</th>
          <th>Cargo</th>
          <th>Status</th>
          <th>Data de criação</th>
          <th>Data de validação</th>
          <th>Ação</th>
        </tr>
        </thead>
        <tbody>
        {users?.map((user) => (
          <UserRow
            key={user.email}
            onClick={() => handleRedirect(user)}
            user={user}
          />
        ))}
        </tbody>
      </table>
    ) : (
      <div className={classes.noData}>
        <NotFoundMessage message='Nenhum registro encontrado' />
      </div>
    )
  )
}

export default UserTable
